import classNames from 'classnames';
import React, { CSSProperties, ReactNode, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import ReactDOM from 'react-dom';

interface LoaderProps {
    style?: CSSProperties;
    wrapperStyle?: CSSProperties;
    message?: string | ReactNode;
    overlay?: boolean;
    content?: string | boolean;
    variant?: string;
    className?: string;
    block?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
    style = {
        width: '2rem',
        height: '2rem',
    },
    wrapperStyle = {},
    message = null,
    overlay = false,
    content = false,
    variant = 'primary',
    className = '',
    block = false,
}) => {
    const [portalItem, setPortalItem] = useState<HTMLElement | null>(null);

    useEffect(() => {
        if (content) {
            setPortalItem(document.getElementById(typeof content === 'string' ? content : 'kt_content'));
        }
    }, [content]);

    const loaderElement = (
        <div
            className={classNames('loader justify-content-center align-items-center', className, {
                'loader--overlay': overlay,
                'loader--content': content,
                'loader--block': block,
            })}
            style={wrapperStyle}
        >
            {overlay && <div className="loader__overlay" />}
            <div
                className={`loader__content ${
                    message ? 'd-flex flex-column justify-content-center align-items-center text-center w-100' : ''
                }`}
            >
                <Spinner style={style} animation="border" className="" variant={variant} role="status" />
                {message && <div className="mt-5">{message}</div>}
            </div>
        </div>
    );

    if (content && !portalItem) {
        return null;
    }

    return portalItem ? ReactDOM.createPortal(loaderElement, portalItem) : loaderElement;
};

export default Loader;
